






















import Vue from 'vue'
import { TopupPickerInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'TopupPickerEl',
  props: {
    templateItemData: {
      type: Object as () => TopupPickerInterface,
      required: true
    }
  },
  data: () => ({
    selectedValue: 0
  }),
  mounted () {
    this.selectedValue = this.templateItemData.defaultValue
  },
  methods: {
    getInputRefs (): URLSearchParams | null {
      return new URLSearchParams({ amount: this.selectedValue.toString() })
    }
  }
})
